// extracted by mini-css-extract-plugin
module.exports = {"tableMessageArea":"TableMessageArea_tableMessageArea__126oJ","tableErrorMessage":"TableMessageArea_tableErrorMessage__VRYRN"};